export const jobColorLightness = 70;

export interface DayOptimisationOverviewResponse {
    jobTypeSummaries: DayOptimisationJobTypeSummary[];
    chartSummary: DayOptimisationChartSummary;
}

export interface DayOptimisationJobTypeSummary {
    name: string;
    workersCount: number;
    standardHours: number;
    overtimeHours: number;
    weekendHours: number;
    holidayHours: number;
}

export interface DayOptimisationChartSummary {
    items: DayOptimisationChartJob[];
}

export interface DayOptimisationChartJob {
    name: string;
    value: number;
}